import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ConsentToggle } from "./consent/ConsentToggle";
import { ProcessingHistory } from "./consent/ProcessingHistory";
import { useConsentManager } from "./consent/useConsentManager";

export function AIConsentManager() {
  const {
    consentStatus,
    processingLogs,
    isLoading,
    updateConsent,
    requestDataDeletion
  } = useConsentManager();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4 sm:p-8" role="status" aria-label="Laster inn personverninnstillinger">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
        <span className="sr-only">Laster inn personverninnstillinger</span>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      <Card className="w-full">
        <CardHeader className="space-y-1 p-4">
          <CardTitle className="text-lg sm:text-xl">Personverninnstillinger</CardTitle>
          <CardDescription className="text-sm">
            Administrer dine samtykker for AI-assistenten. Du kan når som helst trekke tilbake ditt samtykke.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 p-4">
          <ConsentToggle
            title="Databehandling"
            description="Tillat behandling av dine data for AI-assistanse. Dette er nødvendig for at AI-assistenten skal kunne hjelpe deg."
            checked={consentStatus.data_processing}
            onCheckedChange={() => updateConsent('data_processing')}
            aria-label="Samtykke til databehandling"
          />
          <ConsentToggle
            title="Datalagring"
            description="Tillat lagring av dine interaksjoner for forbedret assistanse. Data lagres sikkert og kryptert."
            checked={consentStatus.data_storage}
            onCheckedChange={() => updateConsent('data_storage')}
            aria-label="Samtykke til datalagring"
          />
          <ConsentToggle
            title="Dataanalyse"
            description="Tillat analyse av dine data for å forbedre tjenesten. All analyse gjøres anonymisert."
            checked={consentStatus.data_analysis}
            onCheckedChange={() => updateConsent('data_analysis')}
            aria-label="Samtykke til dataanalyse"
          />
          <div className="mt-6 space-y-4">
            <Button
              variant="destructive"
              className="w-full sm:w-auto"
              onClick={requestDataDeletion}
              aria-label="Be om sletting av data"
            >
              Be om sletting av data
            </Button>
            <p className="text-sm text-muted-foreground">
              Ved å slette dine data vil all personlig informasjon bli permanent fjernet fra våre systemer.
              Dette kan påvirke AI-assistentens evne til å gi personlig tilpasset hjelp.
            </p>
          </div>
        </CardContent>
      </Card>

      <ProcessingHistory logs={processingLogs} />
    </div>
  );
}